/* eslint-disable no-nested-ternary */
<template>
  <div class="card provider-network-rich-state">
    <header>
      <div>
        <h6 class="is-uppercase"><strong>Network State</strong></h6>
      </div>
      <div class="ml-4" v-if="showRefresh">
        <b-button type="is-outlined" size="is-small" icon-left="sync" @click="refreshProviderState" :loading="isLoadingProviderState">Refresh</b-button>
      </div>
    </header>
    <div v-if="isLoadingProviderState" class="has-text-centered">
      <b-progress show-value>Fetching network state...</b-progress>
    </div>
    <div v-else class="network-wrapper">
      <b-notification type="is-warning" :closable="false" :active="isOutOfSync && !syncInProgress" aria-close-label="Close notification" role="alert">
        <div class="is-flex is-space-between">
          <span>Remote is not synchronized, please contact Kymeta Support.</span>
          <b-button type="is-outlined" size="is-small" @click="goToConfig" v-if="isOutOfSync && canViewConfiguration && showConfigLink" >View Configuration</b-button>
        </div>
      </b-notification>
      <b-notification type="is-info" :closable="false" :active="isOutOfSync && syncInProgress" aria-close-label="Close notification" role="alert" >
        Sync is currently in progress.
      </b-notification>

      <b-table
        :data="remoteData" 
        class="has-horizontal-scroll is-full-height richstate" 
        ref="table" 
        detailed hoverable
        :show-detail-icon="!hasVelocitySub" 
        :has-detailed-visible=" (row, index) => (row.title == 'Sat Beam Provisioned') || (row.title == 'Sat Beam Activated') ? true : false">
        <b-table-column field="title" label="State" v-slot="props" cell-class="lr-padding-remove" header-class="lr-padding-remove">
          <span :class="props.row.titleClass"> {{ props.row.title }}</span>
        </b-table-column>
        <b-table-column field="kymetaStatus" label="Kymeta Status" v-slot="props" cell-class="lr-padding-remove" header-class="lr-padding-remove">
          <b-skeleton v-if="syncInProgress" :animated="syncInProgress"></b-skeleton>
          <span v-else>{{ props.row.kymetaStatus }}</span>
        </b-table-column>
        <b-table-column field="networkStatus" label="Network Status" v-slot="props" cell-class="lr-padding-remove" header-class="lr-padding-remove">
          <b-skeleton v-if="syncInProgress" :animated="syncInProgress"></b-skeleton>
          <span v-else :class="props.row.cls">{{ props.row.networkStatus }}</span>
        </b-table-column>

        <template slot="detail" slot-scope="props">
          <div class="detail-grid" v-show="props.row.title == 'Sat Beam Provisioned'">
            <div></div>
            <div>
              <label class="has-text-weight-medium border-bottom">Required</label>
              <br/><b-skeleton v-if="syncInProgress" :animated="syncInProgress"></b-skeleton>
              <div v-else v-for="(kymBeam, kbixp) in kymetaBeams" :key='kbixp'>
                <p v-if="!!kymBeam.isRequired" :class="!!kymBeam.isRequired && isInOnNmsListColumn(kymBeam.networkId) ? '':'has-text-danger'"> {{ kymBeam.displayName }} </p>
              </div>
            </div>
            <div>
              <label class="has-text-weight-medium border-bottom">On NMS</label>
              <br/><b-skeleton v-if="syncInProgress" :animated="syncInProgress"></b-skeleton>
              <div v-else v-for="(remBeam, rbixp) in remoteBeams" :key='rbixp'>
                <p v-if="!!remBeam.provisioned" :class="isInRequiredListColumn(remBeam.networkId) ? '':'has-text-danger'"> {{ remBeam.name }}</p> 
              </div>
            </div>
          </div>
          <div class="detail-grid" v-show="props.row.title == 'Sat Beam Activated'">
            <div></div>
            <div>
              <label class="has-text-weight-medium border-bottom">Required</label>
              <br/><b-skeleton v-if="syncInProgress" :animated="syncInProgress"></b-skeleton>
              <div v-else v-for="(kymBeam, kbixa) in kymetaBeams" :key='kbixa'>
                <p v-if="!!kymBeam.isRequired && !!remote.activated && !!(remoteBeams.length >= 0)" :class="!!kymBeam.isRequired && isInOnNmsListColumn(kymBeam.networkId)  ? '':'has-text-danger'"> {{ kymBeam.displayName }} </p>
              </div >
            </div>
            <div>
              <label class="has-text-weight-medium border-bottom">On NMS</label>
              <br/><b-skeleton v-if="syncInProgress" :animated="syncInProgress"></b-skeleton>
              <div v-else v-for="(remBeam, rbixa) in remoteBeams" :key='rbixa'>
                <p v-if="!!remBeam.activated" :class="isInRequiredListColumn(remBeam.networkId) ? '':'has-text-danger'"> {{ remBeam.name }}</p> 
              </div>
            </div>
          </div> 
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import { orderBy } from 'lodash';

export default {
  props: {
    showConfigLink: {
      type: Boolean,
      default: true,
    },
    showRefresh: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    goToConfig() { this.$router.push({ name: 'remoteConfiguration' }); },
    async refreshProviderState() {
      await this.$store.dispatch('fetchProviderNetworkRichState', {
        id: this.remote.id,
      });
    },
    getRemoteStatus(objRemote, hasVeloSub) {
      const states = [];

      if (this.showSatelliteRows) {
        if (hasVeloSub) {
          states.push({
            title: 'Sat Provisioned',
            kymetaStatus: this.showSatelliteRows && objRemote?.provisioned ? 'Yes' : 'No',
            networkStatus: objRemote?.satellite?.provisioned ? 'Yes' : 'No',
            cls: objRemote?.satellite?.provisioned ? 'has-text-success' : 'has-text-danger',
            titleClass: ''
          });

          states.push({
            title: 'Sat Activated',
            kymetaStatus: this.showSatelliteRows && objRemote?.activated ? 'Yes' : 'No',
            networkStatus: objRemote?.satellite?.activated ? 'Yes' : 'No',
            cls: objRemote?.satellite?.activated ? 'has-text-success' : 'has-text-danger',
            titleClass: ''
          });
        } else {
          const reqKymetaBeams = this.kymetaBeams?.filter(kb => !!kb.isRequired);
          let networkStatusTextProv = 'No';
          if (this.onNmsBeamIsInSyncWrtProv) networkStatusTextProv = 'Yes';
          let networkStatusColorProv = 'has-text-danger'; 
          if (!(objRemote?.provisioned) && this.provisionedBeams?.length == 0 && reqKymetaBeams?.length == 0) networkStatusColorProv = 'has-text-success';
          else networkStatusColorProv = this.onNmsBeamIsInSyncWrtProv && objRemote?.provisioned ? 'has-text-success' : 'has-text-danger'; 

          let networkStatusTextAct = 'No';
          if (this.onNmsBeamIsInSyncWrtAct) networkStatusTextAct = 'Yes';
          let networkStatusColorAct = 'has-text-danger';
          if (!(objRemote?.activated) && this.activatedBeams?.length == 0 && reqKymetaBeams?.length >= 0) networkStatusColorAct = 'has-text-success';
          else networkStatusColorAct = this.onNmsBeamIsInSyncWrtAct ? 'has-text-success' : 'has-text-danger'; 

          states.push({
            title: 'Sat Beam Provisioned',
            kymetaStatus: this.showSatelliteRows && objRemote?.provisioned ? 'Yes' : 'No',
            networkStatus: networkStatusTextProv,
            cls: networkStatusColorProv,
            titleClass: ''
          });

          states.push({
            title: 'Sat Beam Activated',
            kymetaStatus: this.showSatelliteRows && objRemote?.activated ? 'Yes' : 'No',
            networkStatus: networkStatusTextAct,
            cls: networkStatusColorAct,
            titleClass: ''
          });
        }
      }

      let kymetaStatusTextProv = '-';
      let networkStatusTextProv = '-';
      let kymetaStatusTextAct = '-';
      let networkStatusTextAct = '-';

      if (this.showSatelliteRows && this.isCellHwAvailable) {
        if (objRemote?.provisioned) kymetaStatusTextProv = 'Yes';
        else kymetaStatusTextProv = 'No';

        if (this.showCellularRows && this.isCellHwAvailable) networkStatusTextProv = 'Yes';
        else networkStatusTextProv = 'No';

        if (objRemote?.activated && objRemote.enableCellTraffic && this.showCellularRows && this.isCellHwAvailable) kymetaStatusTextAct = 'Yes';
        else kymetaStatusTextAct = 'No';

        if (objRemote?.cellular?.activated) networkStatusTextAct = 'Yes';
        else networkStatusTextAct = 'No';

        states.push({
          title: 'Cell Provisioned',
          kymetaStatus: kymetaStatusTextProv,
          networkStatus: networkStatusTextProv,
          cls: this.showCellularRows && this.isCellHwAvailable ? 'has-text-success' : 'has-text-danger',
          titleClass: !this.isCellHwAvailable ? 'has-text-grey' : ''
        });

        states.push({
          title: 'Cell Activated',
          kymetaStatus: kymetaStatusTextAct,
          networkStatus: networkStatusTextAct,
          cls: kymetaStatusTextAct == networkStatusTextAct ? 'has-text-success' : 'has-text-danger',
          titleClass: !this.isCellHwAvailable ? 'has-text-grey' : ''
        });
      }
      
      if (this.showSatelliteRows && this.isHydHWAvailable) {
        if (objRemote?.provisioned) kymetaStatusTextProv = 'Yes';
        else kymetaStatusTextProv = 'No';

        if (objRemote?.hybrid?.provisioned && this.isHydHWAvailable) networkStatusTextProv = 'Yes';
        else networkStatusTextProv = 'No';

        if (objRemote?.activated) kymetaStatusTextAct = 'Yes';
        else kymetaStatusTextAct = 'No';

        if (objRemote?.hybrid?.activated && this.isHydHWAvailable) networkStatusTextAct = 'Yes';
        else networkStatusTextAct = 'No';

        states.push({
          title: 'Hybrid Provisioned',
          kymetaStatus: kymetaStatusTextProv,
          networkStatus: networkStatusTextProv,
          cls: objRemote?.hybrid?.provisioned && this.isHydHWAvailable ? 'has-text-success' : 'has-text-danger',
          titleClass: !this.isHydHWAvailable ? 'has-text-grey' : ''
        });

        states.push({
          title: 'Hybrid Activated',
          kymetaStatus: kymetaStatusTextAct,
          networkStatus: networkStatusTextAct,
          cls: kymetaStatusTextAct == networkStatusTextAct ? 'has-text-success' : 'has-text-danger',
          titleClass: !this.isHydHWAvailable ? 'has-text-grey' : ''
        });
      }
      return states;
    },
    isNotNullOrEmptyOrUndefined(obj) {
      return !(obj == null || obj == '' || obj == undefined);
    },
    isInOnNmsListColumn(requiredBeamNetworkId) {
      return this.remoteBeams?.filter(b => b.networkId == requiredBeamNetworkId)?.length > 0;
    },
    isInRequiredListColumn(onNmsBeamNetworkId) {
      return this.kymetaBeams?.filter(b => b.networkId == onNmsBeamNetworkId && !!b.isRequired)?.length > 0;
    }
  },
  computed: {
    remote() { return this.$store.state.remotes.remote; },
    remoteData() { return this.getRemoteStatus(this.remote, this.hasVelocitySub); },
    remoteBeams() { 
      const remoteBeamsList = this.$store.state.remotes?.remote?.beams;
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!remoteBeamsList && remoteBeamsList?.length > 0) return orderBy(remoteBeamsList, ["name"], ["asc"]); 
      return [];
    },
    kymetaBeams() { 
      const kymetaBeamsList = this.$store.state.remotes?.remote?.kymetaBeams;
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!kymetaBeamsList && kymetaBeamsList?.length > 0) return orderBy(kymetaBeamsList, ["displayName"], ["asc"]); 
      return [];
    },
    activeSubscription() { return this.$store.getters.activeSubscription; },
    futureSubscriptions() { return this.$store.getters.futureSubscriptions; },
    hasVelocitySub() {
      return this.activeOrFutureSubscription && this.activeOrFutureSubscription.productShortcode == 'PR_INTFLEX_5x2';
    },
    hasLeptonSub() {
      return this.activeOrFutureSubscription && this.activeOrFutureSubscription.productShortcode == 'PR_LEPTON_NMS';
    },
    hasTransecSub() {
      return this.activeOrFutureSubscription && this.activeOrFutureSubscription.productShortcode.includes('PR_KB_TRANSEC');
    },
    provisionedBeams() {
      if (this.isLoadingProviderState) return [];
      const pBeams = this.remoteBeams;
      if (pBeams == null || pBeams == '' || pBeams == undefined) { return []; }
      return pBeams?.filter((pb) => pb?.provisioned);
    },
    activatedBeams() {
      if (this.isLoadingProviderState) return [];
      const aBeams = this.remoteBeams;
      if (aBeams == null || aBeams == '' || aBeams == undefined) { return []; }
      return aBeams?.filter((ab) => ab?.activated);
    },
    syncInProgress() { return this.remote.syncInProgress; },
    isLoadingProviderState() { return this.$store.state.remotes.isLoadingProviderState; },
    showSatelliteRows() { return this.activeOrFutureSubscription?.hasSatellite }, // if active subs have hasSatellite = true
    showCellularRows() { return this.activeOrFutureSubscription?.hasCellular }, // if active subs have hasCellular = true
    showHybridRows() { return this.activeOrFutureSubscription?.hasCellular }, // if active subs have hasCellular = true
    isCellHwAvailable() {
      return !!this.remote?.devices?.cellRouterIccid
        || this.isHydHWAvailable;
    },
    isHydHWAvailable() {
      return !!this.remote?.devices?.cellRouterImei
          || !!this.remote?.devices?.cellRouterSerial; 
    },
    isOutOfSync() {
      if (!this.activeOrFutureSubscription) return true;
      // Overall status : kymeta status != network status, return outOfSync
      if (!!this.showSatelliteRows && !!this.remoteData) {
        if (this.remoteData?.filter(r => r.kymetaStatus?.toLowerCase()?.includes("no"))?.length > 0) return true;
        if (this.remoteData?.filter(r => r.cls?.toLowerCase()?.includes("has-text-danger"))?.length > 0) return true;
      } else return true;
      // if Lepton sub, Provisioned beams count should match Activated beams count to consider it to be in sync
      if (this.hasLeptonSub && (this.provisionedBeams?.filter(pb => pb.provisioned).length != this.activatedBeams?.filter(ab => ab.activated).length)) return true;

      return false;
    },
    canViewConfiguration() {
      return this.$hasRole('Super User,Kymeta Admin,Product Support,Account Admin,Credentialed');
    },
    activeOrFutureSubscription() {
      if (this.activeSubscription) return this.activeSubscription;
      if (this.futureSubscriptions) return orderBy(this.futureSubscriptions, ['startDate'], ['asc'])[0];
      return null;
    },
    onNmsBeamIsInSyncWrtProv() {
      // isRequired = true, Kymeta beams' list --- (List 1)
      const reqKymetaBeams = this.kymetaBeams?.filter(kb => !!kb.isRequired)?.map(kb => kb.networkId);
      // early exit, if kymetaBeams not available for HW mismatch: antennaType, modemType
      if (reqKymetaBeams?.length == 0) return false;
      // provisioned = true, Remote's Beam list --- (List 2)
      const proRemoteBeams = this.remoteBeams?.filter(rb => !!rb.provisioned)?.map(rb => rb.networkId);
      if (reqKymetaBeams?.length > 0 && reqKymetaBeams?.length != proRemoteBeams?.length) return false;
      // if (List 2) length != 0, find difference in (List 1), (List 2) 
      return proRemoteBeams?.length == 0 ? false : proRemoteBeams?.filter(rb => !reqKymetaBeams?.includes(rb))?.length == 0;
    },
    onNmsBeamIsInSyncWrtAct() {
      // isRequired = true, Kymeta beams' list --- (List 1)
      const reqKymetaBeams = this.kymetaBeams?.filter(kb => !!kb.isRequired)?.map(kb => kb.networkId);
      // early exit, if kymetaBeams not available for HW mismatch: antennaType, modemType
      if (reqKymetaBeams?.length == 0) return false;
      // activated = true, Remote's Beam list --- (List 3)
      const actRemoteBeams = this.remoteBeams?.filter(rb => !!rb.activated)?.map(rb => rb.networkId);
      if (reqKymetaBeams?.length > 0 && reqKymetaBeams?.length != actRemoteBeams?.length) return false;
      if (!this.remote.activated && actRemoteBeams?.length > 0) return false;
      // if (List 3) length != 0, find difference in (List 1), (List 3) 
      return actRemoteBeams?.length == 0 ? false : actRemoteBeams?.filter(rb => !reqKymetaBeams?.includes(rb))?.length == 0;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../styles/_colors";
@import "../../styles/mixins";

.provider-network-rich-state {
  padding: 12px;
}
header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 0px 5px;
}
div:first-child {
  padding-left: 0px;
}
.progress-wrapper {
  margin-top: 12px;
}
.network-wrapper.notification {
  margin: 12px 0px;
}
.strikethrough-inline {
  text-decoration : line-through
 }
.strikethrough-none {
  text-decoration: none
}
.border-bottom {
  border-bottom: 1px solid gray;
}
.detail-grid {
  @include display-grid;
  grid-template-columns: 1.48fr 1fr 1.05fr;
  gap: 5px;
  display: grid;
  position: relative;
}
</style>
